// extracted by mini-css-extract-plugin
export default {"layout":"\"../../../../../styles/variables/layout.module.css\"","breakpoint-l":"960px","breakpoint-xl":"1280px","list":"End_list__IyiLQ"};